import { Component, ErrorInfo, ReactNode } from 'react';
import { reportClientError } from '../utils/errorReporter';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  errorMessage?: string;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, errorMessage: error.message };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    reportClientError({
      type: 'react',
      message: error.message,
      stack: error.stack,
      context: { componentStack: info.componentStack }
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            padding: 24,
            fontFamily: 'system-ui, sans-serif',
            textAlign: 'center'
          }}
        >
          <h2 style={{ margin: 0, color: '#1a2438' }}>
            Ocurrió un error inesperado
          </h2>
          <p style={{ color: '#5b6478', maxWidth: 480 }}>
            La acción no pudo completarse. El equipo técnico fue notificado
            automáticamente. Intenta recargar la página.
          </p>
          {this.state.errorMessage && (
            <pre
              style={{
                background: '#f4f5f8',
                padding: 12,
                borderRadius: 6,
                maxWidth: 600,
                overflow: 'auto',
                fontSize: 12,
                color: '#5b6478'
              }}
            >
              {this.state.errorMessage}
            </pre>
          )}
          <button
            onClick={this.handleReload}
            style={{
              marginTop: 16,
              padding: '10px 20px',
              background: '#5569ff',
              color: 'white',
              border: 'none',
              borderRadius: 6,
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 600
            }}
          >
            Recargar página
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
